package br.com.vvrefeicoes.portal.domain.model

import org.jetbrains.compose.resources.StringResource

data class ConsolidatedSupplier(
    val name: String,
    val realCents: Long,
    val plannedCents: Long,
)

data class ConsolidatedCategory(
    val categoryId: String,
    val title: StringResource,
    val realCents: Long,
    val plannedCents: Long,
    val suppliers: List<ConsolidatedSupplier>,
)

data class ConsolidatedWeek(
    val index: Int,
    val label: String,
    val realCents: Long,
    val plannedCents: Long,
)

data class ConsolidatedCorporate(
    val payrollRealCents: Long,
    val payrollPlannedCents: Long,
    val chargesRealCents: Long,
    val chargesPlannedCents: Long,
    val adminOthersRealCents: Long,
    val adminOthersPlannedCents: Long,
    val taxesRealCents: Long,
    val taxesPlannedCents: Long,
) {
    val realTotalCents: Long
        get() = payrollRealCents + chargesRealCents + adminOthersRealCents + taxesRealCents

    val plannedTotalCents: Long
        get() = payrollPlannedCents + chargesPlannedCents + adminOthersPlannedCents + taxesPlannedCents
}

data class ConsolidatedUnitReport(
    val unitId: String,
    val unitName: String,
    val realTotalCents: Long,
    val plannedTotalCents: Long,
    val weeks: List<ConsolidatedWeek>,
    val categories: List<ConsolidatedCategory>,
    val corporate: ConsolidatedCorporate,
)
